import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "tabContent"]
  static values = {
    fetchInitial: Boolean,
    preserveUrl: Boolean
  }

  connect() {
    this.activeTab = this.tabTargets.find(tab => tab.classList.contains('active'))
    if (this.activeTab) {
      let contentSrc = this.activeTab.dataset.tabsContentSrc
      if (this.fetchInitialValue && contentSrc) {
        this.fetchTabContent(contentSrc) 
      }
    }
  }
  
  switchTab(event) {
    const clickedTab = event.target
    const tabId = clickedTab.dataset.tabId
    
    // Update active tab styling
    this.tabTargets.forEach(tab => {
      const isActive = tab.dataset.tabId === tabId
      tab.classList.toggle('active', isActive)
      tab.classList.toggle('text-blue-600', isActive)
      tab.classList.toggle('border-b-2', isActive)
      tab.classList.toggle('border-blue-600', isActive)
      tab.classList.toggle('text-gray-500', !isActive)
    })
    
    // Show/hide tab content
    this.tabContentTargets.forEach(content => {
      const isActive = content.dataset.tabId === tabId
      const tab = this.tabTargets.find(tab => tab.dataset.tabId === content.dataset.tabId)
      content.classList.toggle('hidden', !isActive)
      if (isActive) {
        if (tab.dataset.tabsContentSrc) {
          this.fetchTabContent(tab.dataset.tabsContentSrc)
          if (this.preserveUrlValue) {
            history.replaceState(null, null, tab.dataset.tabsContentSrc)
          }
        }
      } else {
        if (tab.dataset.tabsContentSrc) {
          content.innerHTML = ''
        }
      }
    })

    this.activeTab = clickedTab
  }

  fetchTabContent(contentSrc) {
    fetch(contentSrc, {
      headers: {
        Accept: "text/vnd.turbo-stream.html",
      }
    })
      .then((response) => response.text())
      .then((html) => {
        Turbo.renderStreamMessage(html)
    })
  }
}
